// src/signalr/dakokuTenkoAlertClient.ts
import * as signalR from "@microsoft/signalr"

let connection: signalR.HubConnection | null = null

export type TDakokuTenkoAlertPayload = {
  打刻点呼アラートID: number
  勤務日: string
  乗務員ID: number
  社員コード: string
  社員氏名: string
  部所コード: string
  部所名: string
  部所略称: string
  打刻点呼アラート区分ID: number
  打刻点呼アラート区分コード: string
  打刻点呼アラート区分名称1: string
  発生日時: string
  既読フラグ: number
  更新日時: string
}

/**
 * 打刻点呼アラート用 SignalR 接続を取得（シングルトン）
 */
export const getDakokuTenkoAlertConnection = () => {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_API_BASE_URL}hubs/dakoku-tenko-alert`, {
        withCredentials: true, // Cookie 認証なので必須
      }) // サーバ側で MapHub したURL
      .withAutomaticReconnect()
      .build()
  }
  return connection
}
